(function () {
    'use strict';
    angular
        .module('MW.Influencers.SourceSwitcherController', ['Configuration'])
        .controller('SourceSwitcherController', [
            '$window',
            '$timeout',
            '$route',
            'IRM_BASE_URL',
            SourceSwitcherController
        ]);

    function SourceSwitcherController($window, $timeout, $route, IRM_BASE_URL) {
        var sourceId = $route.current.params.sourceId;

        $timeout(function () {
            $window.location.replace(`${IRM_BASE_URL}/source/${sourceId}${$window.location.search}`);
        });
    }
}());